// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* ------------------------------------------------------------------------------------------ */
/* Based on the "Color Tokens" view -------------------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

const colors: Styleguide["colors"] = {
    primary: {
        main: "#337761",
        contrast: "#ffffff",
        alt: "#78BE21",
        light: "", // Primary -> Light
        dark: "", // Primary -> Dark
    },
    secondary: {
        main: "#C4D600",
        contrast: "#333333",
        alt: "#F28900",
        light: "", // Secondary -> Light
        dark: "", // Secondary -> Dark
    },
    tertiary: {
        main: "#033873",
        contrast: "#ffffff",
        alt: "#0070CD",
        alt2: "#001A3E",
        light: "", // Tertiary -> Light
        dark: "", // Tertiary -> Dark
    },
    common: {
        border: "#adadac",
        borderLight: "#d4d4d4",
        borderDark: "#adadac",
        borderDarker: "#202b33",
        accent: "#f5f5f5",
        accentContrast: "#333333",
        accentContrastLight: "#333333",
        background: "#ffffff",
        backgroundContrast: "#333333",
        disabled: "#F6F7F9",
        disabledDark: "#C1C8CF",
        gradient1: "linear-gradient(90deg, #337761 60%, #78BE21 110%)",
        gradient2: "linear-gradient(90deg, #033873 60%, #0070CD 110%)",
    },
    text: {
        main: "#333333",
        accent: "#333333",
        disabled: "#C1C8CF",
        link: "#3061C8",
        linkHover: "#033873",
        linkAlt: "#333333",
        linkAltHover: "#337761",
        input: "#333333",
        light: "#808080",
    },
    success: {
        main: "#337761",
        contrast: "#ffffff",
        light: "#ffffff",
    },
    warning: {
        main: "#c45414",
        contrast: "#ffffff",
        light: "#ffffff",
    },
    danger: {
        main: "#DF1642",
        contrast: "#ffffff",
        light: "#ffffff",
    },
    info: {
        main: "#146090",
        contrast: "#ffffff",
        light: "#ffffff",
        alt: "#bcbcbc",
    },
    neutral: {
        main: "#666666",
        contrast: "#ffffff",
        light: "#e0e0e0",
    },
    invert: {
        main: "#ffffff", // None
        contrast: "#0f0f0f", // None
        dark: "#ececec", // None
    },
    placeholder: {
        main: "#bcbcbc",
        disabled: "#e2e2e2",
    },
    button: {
        disabled: {
            main: "#e6e6e6",
            contrast: "#ffffff",
        },
    },
    header: {
        main: "#ffffff",
        contrast: "#333333",
        hover: "#033873",
        accent: "#337761",
        accentHover: "#033873",
        accentContrast: "#ffffff",
        breadcrumbs: "#979797",
    },
    menu: {
        mainNavigation: {
            main: "#ffffff",
            contrast: "#333333",
            hover: "#337761",
            accent: "#337761",
            accentContrast: "#ffffff",
            accentHover: "#337761",
            border: "#adadac",
        },
        secondaryNavigation: {
            main: "#202b33",
            contrast: "#ffffff",
            hover: "#ffffff",
        },
    },
    footer: {
        main: "#333f48",
        contrast: "#C1C8CF",
        alt: "#202b33",
        altContrast: "#bcbcbc",
        closeCookie: "#dedfe0",
    },
    swatch: {
        main: "", // Black & White -> Border
        contrast: "", // Text Color -> Main
        hover: "", // Primary -> Main
        selected: "", // Primary -> Main
        selectedHover: "", // Primary -> Dark
    },
};

export default colors;
